import { Component } from '@wonderlandengine/api';
import { property } from '@wonderlandengine/api/decorators.js';
import { TriggerTarget } from '../interactions/triggerTarget.js';

import { SoundManager, Sounds } from '../core/music-manager.js';

export class PlaySound extends Component {
    static TypeName = 'play-sound';
    private _triggerTarget?: TriggerTarget | null;

    @property.enum(
        Object.keys(Sounds).filter((e) => isNaN(Number(e))),
        Sounds.None
    )
    sound: Sounds = Sounds.None;

    start(): void {
        this._triggerTarget = this.object.getComponent(TriggerTarget)!;
    }

    onActivate(): void {
        this._triggerTarget?.onExecute.add(this._onExecute);
    }

    onDeactivate(): void {
        this._triggerTarget?.onExecute.remove(this._onExecute);
    }

    private _onExecute = () => {
        SoundManager.instance.play(this.sound);
    };
}
